import {
  Avatar,
  AvatarGroup,
  Box,
  Divider,
  Flex,
  Text,
  Tooltip,
  useTheme,
} from '@chakra-ui/react';
import { Fragment } from 'react';
import RowList from '../../nesting/RowList';
import { useTeamTableContext } from '../../context/TeamTableContext';
import { NoTeamIcon } from '../../../icons';
import { MembersDataItem } from '../../types/team-table.types';

export default function MembersCell({
  cellData,
  subRows,
  level,
}: {
  cellData: MembersDataItem;
  level: number;
  subRows: MembersDataItem[];
}) {
  const { colors } = useTheme();
  const { expanded } = useTeamTableContext();

  return (
    <>
      <Fragment>
        <Flex
          direction="column"
          align="flex-start"
          minH="184px"
          w="149px"
          p={3}
          pl={4}
          bg="white"
        >
          <Box>
            <Text fontSize={'sm'} ml={2} color={colors.text.secondary}>
              Managers ({cellData.managers?.length || 0})
            </Text>
            <Tooltip
              hasArrow
              label={
                <Flex direction={'column'}>
                  {cellData.managers?.map((item: string) => (
                    <Box>{item}</Box>
                  ))}

                  {cellData.managers?.length === 0 && (
                    <Text>No Managers Assigned</Text>
                  )}
                </Flex>
              }
            >
              <AvatarGroup size="xs" ml={2}>
                {cellData.managers?.slice(0, 4).map((item: string) => (
                  <Avatar name={item} />
                ))}
                {cellData.managers?.length === 0 && (
                  <NoTeamIcon color="red" width={19} height={19} />
                )}
              </AvatarGroup>
            </Tooltip>
          </Box>
          <Box my={3}>
            <Text fontSize={'sm'} ml={2} color={colors.text.secondary}>
              Members ({cellData.members?.length || 0})
            </Text>
            <Tooltip
              hasArrow
              label={
                <Flex direction={'column'}>
                  {cellData.members?.map((item: string) => (
                    <Box>{item}</Box>
                  ))}

                  {cellData.members?.length === 0 && (
                    <Text>No Members Assigned</Text>
                  )}
                </Flex>
              }
            >
              <AvatarGroup size="xs" ml={2}>
                {cellData.members?.slice(0, 4).map((item: string) => (
                  <Avatar name={item} />
                ))}
                {cellData.members?.length === 0 && (
                  <NoTeamIcon color="red" width={19} height={19} />
                )}
              </AvatarGroup>
            </Tooltip>
          </Box>
          <Box>
            <Text fontSize={'sm'} ml={2} color={colors.text.secondary}>
              SubTeams ({cellData.subTeamsList?.length || 0})
            </Text>
            <Tooltip
              label={
                <Flex direction={'column'}>
                  {cellData.subTeamsList?.map((item: string) => (
                    <Box>{item}</Box>
                  ))}
                  {cellData.subTeamsList?.length === 0 && (
                    <Text>No Sub Teams Assigned</Text>
                  )}
                </Flex>
              }
              hasArrow
            >
              <AvatarGroup size="xs" ml={2}>
                {cellData.subTeamsList?.slice(0, 4).map((item: string) => (
                  <Avatar name={item} />
                ))}
                {cellData.subTeamsList?.length === 0 && (
                  <NoTeamIcon color="red" width={19} height={19} />
                )}
              </AvatarGroup>
            </Tooltip>
          </Box>
        </Flex>
        <Divider />
      </Fragment>
      {subRows && subRows.length > 0 && expanded.includes(cellData.name) && (
        <RowList colKey="MEMBERS" rows={subRows} level={level + 1} />
      )}
    </>
  );
}
